export const config = {    
    // base_url:'https://websitebackend126.altostechnologies.in/',
    // imgurl : "https://websitebackend126.altostechnologies.in",

    baseurl : "https://websitebackend181.altostechnologies.in/",
    imgurl : "https://websitebackend181.altostechnologies.in",
}